module.exports = __webpack_public_path__ + "static/media/gator-reports-logo.4124113e.svg";